import { Observable } from 'rxjs';

export * from './appendable-observable';

export function resizeObservable(el: Element) {
  return new Observable<ResizeObserverEntry[]>((subscriber) => {
    const observer = new ResizeObserver((entries) => subscriber.next(entries));
    observer.observe(el);

    return () => observer.disconnect();
  });
}
